import { ListItem, ListItemButton, ListItemText, ListItemIcon, Box } from "@mui/material"
import { useState } from "react"
import { Link } from "react-router-dom"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import ExpandLessIcon from "@mui/icons-material/ExpandLess"
import styles from "../sideMenu.module.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const MenuList = ({ text, expandedModule, expandedSubModule, isSideMenuExpanded, isHover }) => {
    const buttonHeight = 45
    const isDirectLink = !!text?.path

    const [showSubMenu, setShowSubMenu] = useState(text?.routeId === expandedModule)

    const isActive = text.routeId === expandedModule &&
        (isDirectLink || ((text?.children?.map(item => item.id).includes(expandedSubModule) || (!expandedSubModule && text?.children?.some(item => item.path === `/${expandedModule}`))) && showSubMenu))

    return (
        <>
            <ListItem
                key={text}
                disablePadding
                sx={
                    isActive
                        ? {
                              display: "block",
                              borderLeft: "3.5px solid #404767",
                              height: buttonHeight,
                          }
                        : {
                              display: "block",
                              height: buttonHeight,
                          }
                }>
                <ListItemButton
                    sx={[
                        {
                            minHeight: buttonHeight,
                            px: 1,
                            height: buttonHeight,
                        },
                        isSideMenuExpanded || isHover
                            ? {
                                  justifyContent: "initial",
                              }
                            : {
                                  justifyContent: "center",
                              },
                    ]}
                    className={styles.list_container_button}
                    {...(isDirectLink
                        ? { component: Link, to: text.path }
                        : { onClick: () => setShowSubMenu(!showSubMenu) }
                    )}>
                    <ListItemIcon
                        sx={[
                            {
                                minWidth: 0,
                                justifyContent: "center",
                                height: 16,
                                width: 16,
                            },
                            isSideMenuExpanded || isHover
                                ? {
                                      mr: 1,
                                  }
                                : {},
                        ]}>
                        {isActive ? (
                            <FontAwesomeIcon
                                icon={text?.activeIcon}
                                style={{
                                    "--fa-primary-color": "#404767",
                                    "--fa-secondary-color": "#9195ab",
                                    "--fa-secondary-opacity": "1",
                                }}
                            />
                        ) : (
                            <FontAwesomeIcon icon={text?.icon} style={{ color: "9195ab" }} />
                        )}
                    </ListItemIcon>

                    {(isSideMenuExpanded || isHover) && (
                        <ListItemText
                            primary={text?.label}
                            sx={{
                                opacity: 1,
                                m: 0,
                                whiteSpace: "nowrap",
                                "& .MuiListItemText-primary": {
                                    fontSize: "14px",
                                    color: isActive ? "#101941" : "#5F6580",
                                    fontWeight: isActive ? 500 : 400,
                                    lineHeight: 1,
                                },
                                
                            }}
                        />
                    )}

                    {!isDirectLink && text?.children?.length > 0 && (isSideMenuExpanded || isHover) && (
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}>
                            {showSubMenu ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </Box>
                    )}
                </ListItemButton>
            </ListItem>

            {!isDirectLink && showSubMenu && (isSideMenuExpanded || isHover) && (
                <ListItem key={text?.routeId} disablePadding sx={{ display: "block" }}>
                    {text?.children?.map(child => (
                        <ListItemButton
                            key={child?.id || child?.name}
                            sx={{
                                // minHeight: buttonHeight,
                                // height: buttonHeight,
                                mx: 1,
                                borderRadius: "4px",
                                justifyContent: "initial",
                                paddingTop : "10px",
                                paddingBottom : "10px",
                                pl: 5,
                                backgroundColor:
                                    text.routeId === expandedModule && expandedSubModule === child?.id
                                        ? "#EBEEFD"
                                        : "transparent",
                                "&:hover": {
                                    backgroundColor:
                                        text.routeId === expandedModule && expandedSubModule === child?.id
                                            ? "#EBEEFD"
                                            : "rgba(0, 0, 0, 0.04)",
                                    "& .MuiListItemText-primary": {
                                        fontWeight: 500,
                                        color: "#101941",
                                    },
                                },
                            }}
                            component={Link}
                            to={child?.path}>
                            {(isSideMenuExpanded || isHover) && (
                                <ListItemText
                                    primary={child?.label}
                                    sx={{
                                        m: 0,
                                        opacity: 1,
                                        "& .MuiListItemText-primary": {
                                            fontSize: "14px",
                                            color:
                                                text.routeId === expandedModule && expandedSubModule === child?.id
                                                    ? "#101941"
                                                    : "#5F6580",
                                            fontWeight:
                                                text.routeId === expandedModule && expandedSubModule === child?.id
                                                    ? 500
                                                    : 400,
                                            lineHeight: 1.3,
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                        },
                                    }}
                                />
                            )}
                        </ListItemButton>
                    ))}
                </ListItem>
            )}
        </>
    )
}

export default MenuList
